import { MapPinSimpleArea } from "@phosphor-icons/react/dist/ssr";

import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import type { TCity } from "..";

interface CitySearchProps {
  formName: "hotel" | "tour";
  city: TCity;
  onClick: (value: {
    name: string;
    id: string | number;
    type: string | undefined;
    code: string;
  }) => void;
}

export default function CitySearch({
  formName,
  city: { fa_name, id, name, iata },
  onClick,
}: CitySearchProps) {
  return (
    <Flex
      className="flex-col w-full h-full border-b py-1 px-2 flex gap-3 gap-y-1 items-center"
      key={`${name}-${id}`}
    >
      <Flex className="w-full flex-col gap-y-2">
        <Flex
          className="w-full justify-start items-center gap-x-2 cursor-pointer hover:bg-muted dark:hover:bg-muted/10transition-all duration-150 py-1 rounded-xs px-1"
          onClick={() =>
            onClick({
              name: fa_name || name,
              id,
              type: "city",
              code: formName === "tour" ? name : iata,
            })
          }
        >
          <MapPinSimpleArea className="text-primary" />
          <Typography className="font-medium">{fa_name}</Typography>
        </Flex>
      </Flex>
    </Flex>
  );
}
